import classNames from 'clsx';
import { NavIcon } from '../../NavIcon';

/**
 * Botón chico de sistema del Rail (campana, Centro de ayuda): ícono solo, sin fila ni
 * etiqueta, como la campana de la barra del celular (JP, 19/10). 32px expandido (a la
 * derecha del logo) y 36px contraído (la baldosa de los demás ítems). Con el panel
 * abierto (`data-state=open` del Popover) se marca como el ítem activo: baldosa azul.
 * Lo usan la campana real, el Centro de ayuda y el story del Rail.
 */
export const railIconButtonClass = (collapsed: boolean): string =>
  classNames(
    'group relative grid shrink-0 place-items-center rounded-lg text-frost-ink-soft outline-hidden',
    'transition-colors duration-200 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)]',
    'hover:bg-[rgba(var(--f-ink-rgb),0.05)] hover:text-frost-ink',
    'focus-visible:ring-2 focus-visible:ring-frost-brand/30 focus-visible:ring-offset-1',
    'data-[state=open]:bg-frost-brand data-[state=open]:text-white',
    collapsed ? 'h-9 w-9' : 'h-8 w-8'
  );

/** Ícono del botón: 13px expandido, 14px contraído (como los demás íconos del riel). */
export const railIconButtonIconClass = (collapsed: boolean): string =>
  classNames('shrink-0', collapsed ? 'text-fs-14' : 'text-fs-13');

export const RailBellIcon = ({ collapsed = false }: { collapsed?: boolean }) => (
  <NavIcon name="bell" className={railIconButtonIconClass(collapsed)} />
);

/** Punto de no leídas: el único rojo de la barra, quieto (sin pulso), como en el celular. */
export const railUnreadDotClass =
  'absolute top-[5px] right-[5px] h-[8px] w-[8px] rounded-full bg-frost-coral ring-2 ring-frost-card';
